import React from "react";
import useElements from "../hooks/useElements";
import { ElementsViewer } from "@wuilt/section-preview";
import { migrateElement } from "./button-migration";
function Button({
  value,
  className,
  type,
  size
}) {
  const wuiltContext = useElements();
  const element = migrateElement(value.id, value, {
    type,
    size
  });
  const settings = element.settings;
  if (value.hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ElementsViewer.Button, {
    element: element,
    text: {
      [settings.textId]: settings?.text
    },
    wuiltContext: wuiltContext,
    customClassName: className,
    minWidth: "max-content"
  });
}
export default Button;
//# sourceMappingURL=Button.js.map